import { useDocumentAI } from "hooks/useDocumentAI";

import {
  AddEditDocumentDialog,
  AddEditDocumentDialogProps,
  defaultAddEditDocumentDialogState,
  EditMode,
} from "../AddEditDocumentDialog";
import { AddEditDocumentWithAIEnrichmentDialog } from "../AddEditDocumentWithAIEnrichmentDialog";
import {
  ReviewDocumentMetadataDialog,
  ReviewDocumentMetadataDialogProps,
} from "../ReviewDocumentMetadataDialog";

type AddEditDialogPropOverrides = Omit<AddEditDocumentDialogProps, "tenantId">;

type ReviewDialogPropOverrides = Omit<ReviewDocumentMetadataDialogProps, "tenantId">;

type DocumentDialogProps = {
  tenantId?: string;
  // Review dialog props (when provided, shows review dialog)
  reviewDialogProps?: ReviewDialogPropOverrides;
  // Add/Edit dialog props (when reviewDialogProps is not provided)
  addEditDialogProps: AddEditDialogPropOverrides;
};

export function DocumentDialog(props: DocumentDialogProps) {
  const { tenantId, reviewDialogProps, addEditDialogProps } = props;

  const hasDocumentAI = useDocumentAI();

  if (!tenantId) {
    return null;
  }

  // Handle review dialog mode
  if (hasDocumentAI && reviewDialogProps?.open) {
    return (
      <ReviewDocumentMetadataDialog
        tenantId={tenantId ?? ""}
        hasDocumentAI={hasDocumentAI}
        {...reviewDialogProps}
      />
    );
  }

  if (hasDocumentAI && addEditDialogProps?.dialogState?.mode === EditMode.ADD) {
    return (
      <AddEditDocumentWithAIEnrichmentDialog
        open={addEditDialogProps?.dialogState?.open}
        tenantId={tenantId}
        onClose={() => {
          addEditDialogProps?.setDialogState?.(defaultAddEditDocumentDialogState);
        }}
      />
    );
  }

  return <AddEditDocumentDialog tenantId={tenantId} {...addEditDialogProps} />;
}
